// /editor-v4/:id — thin route wrapper around the shared <CreativeEditor>.
// The editor guts were extracted to components/feature/CreativeEditor.tsx so the
// SAME editor can be embedded (wizard finish step) or routed here. This wrapper
// just maps the URL :id to the component + syncs navigation.

import { useNavigate, useParams } from 'react-router-dom';
import CreativeEditor from '@/components/feature/CreativeEditor';

export default function EditorV4Page() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-surface text-dark">
        <p>No creative selected.</p>
        <button onClick={() => navigate('/gallery')} className="px-4 h-10 rounded-full bg-primary text-white text-sm font-bold cursor-pointer">Back to My Creatives</button>
      </div>
    );
  }

  return (
    <CreativeEditor
      initialPostId={id}
      backLabel="My Creatives"
      onBack={() => navigate('/gallery')}
      onActivePostChange={(pid) => navigate(`/editor-v4/${pid}`, { replace: true })}
      onDeleted={() => navigate('/gallery')}
      showDelete
    />
  );
}
